import { c as _c } from "react/compiler-runtime";
import './initials-avatar.scss';
import React from 'react';
import { cn } from '@sola/ark-core/utils/helpers.ts';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
const iconSize = {
  sm: '16px',
  md: '24px',
  lg: '32px'
};
export const InitialsAvatar = t0 => {
  const $ = _c(14);
  const {
    size: t1,
    initials,
    notificationCount,
    className
  } = t0;
  const size = t1 === undefined ? "sm" : t1;
  const t2 = size === "sm";
  const t3 = size === "md";
  const t4 = size === "lg";
  let t5;
  if ($[0] !== className || $[1] !== t2 || $[2] !== t3 || $[3] !== t4) {
    t5 = cn("InitialsAvatar flex flex-col items-center justify-center relative text-center", {
      "InitialsAvatar--sm label-md label-potent": t2,
      "InitialsAvatar--md label-xl label-potent": t3,
      "InitialsAvatar--lg heading-sm label-potent": t4
    }, className);
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== initials || $[6] !== size) {
    t6 = initials ?? <ArkIcon iconName="user-01" size={iconSize[size]} />;
    $[5] = initials;
    $[6] = size;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== notificationCount) {
    t7 = !!notificationCount && <span className="InitialsAvatar__notificationCount absolute label-sm label-potent">{notificationCount}</span>;
    $[8] = notificationCount;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t5 || $[11] !== t6 || $[12] !== t7) {
    t8 = <div className={t5}>{t6}{t7}</div>;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
};